import { Button } from "@mui/material";
import { makeStyles, createStyles } from '@mui/styles';

export const Buttons = (props) =>{
    let bgColor;
    let color;
    let hovColor;
    if (props.color === 'primary') {
        bgColor = '#0070EF';
        color = '#FFFFFF';
        hovColor = '#0984E3';
    }else if(props.color === 'primaryBiz'){
        bgColor = '#295F47';
        color = '#FFFFFF';
        hovColor = '#1F845A';
    }else if(props.color === 'noBiz'){
        bgColor = '#dbfceeff';
        color = '#FFFFFF';
        hovColor = '#121212';
    }else if(props.color === 'secondary'){
        bgColor = '#ffb347';
        color = '#FFFFFF';
        hovColor = '#ffb347';
    }else if(props.color === 'disabled' || props.disabled){
        bgColor = '#AEE1C3';
        color = '#6EC49A';
        hovColor = '#AEE1C3';
    }else if(props.color === 'cancel'){
        bgColor = '#D3D3D3';
        color = '#121212';
        hovColor = '#D3D3D3';
    }else if(props.color === 'skip'){
        bgColor = '#d6eaff';
        color = '#121212';
        hovColor = '#e9f4ff';
    }else if(props.color === 'removeCancel'){
        bgColor = '#E3EDF8';
        color = '#000';
        hovColor = '#c5e6ff';
    }else if(props.color === 'default'){
        bgColor = '#64CC90';
        color = '#FFFFFF';
        hovColor = '#127A3E';
    }else{
        if (props.color === '#ffffff') {
            bgColor = props.color;                  
            color = '#000000';
            hovColor = props.color;
        }else{
            bgColor = props.color;
            color = '#FFFFFF';
            hovColor = props.color;
        }
    }
    
    const useStyles = makeStyles(() =>
        createStyles({
            btn:{
                margin:props.margin,
                textTransform:'none',
                backgroundColor: props.variant === 'contained' ? bgColor :'none',
                border:`${props.disabled ? '' : bgColor} solid 1px`,
                color: props.variant === 'contained' ? color : '#000000',
                width:props.width,
                height:props.height,
                fontSize:props.fontSize,
                borderRadius:props.borderRadius,
                fontFamily: [
                    '-apple-system',
                    '"Inter"',
                ].join(','),
                '&:hover': {
                    backgroundColor: hovColor,
                    color:color,
                },
            }
        }),
    )
    const classes = useStyles();
    return (
        <Button disabled={props.disabled} onClick={props.event} startIcon={props.startIcon} className={`${classes.btn} ${props.className || ''}`} variant={props.variant} >{props.text}</Button>
    )
}